import Revelar from './Revelar';
import styles from './LandingBase.module.css';

const passos = [
  {
    titulo: 'Crie sua conta',
    descricao: 'Leva menos de dois minutos. Sem cartão pra começar e sem planilha pra configurar.'
  },
  {
    titulo: 'Lance seus gastos em segundos',
    descricao: 'Adicione contas e cartões e registre movimentações no lançamento rápido: data de hoje e conta já preenchidas, poucos toques e pronto.'
  },
  {
    titulo: 'Deixe o app pensar por você',
    descricao: 'Dashboard com insights, projeção de fim de mês, metas que avisam quando estouram e fatura estimada do cartão. Você só decide.'
  }
];

const Testimonial = () => {
  return (
    <section id="como" className={`${styles.section} ${styles.sectionAlt}`}>
      <Revelar>
        <div className={styles.sectionHead}>
          <span className={styles.eyebrow}>Como funciona</span>
          <h2 className={styles.sectionTitle}>Do caos ao controle em 3 passos</h2>
          <p className={styles.sectionSub}>Sem curva de aprendizado. Você começa hoje e já entende para onde vai seu dinheiro.</p>
        </div>
      </Revelar>

      <div className={styles.steps}>
        {passos.map((p, i) => (
          <Revelar key={p.titulo} atraso={i * 80} className={styles.cardWrap}>
            <div className={styles.step}>
              <span className={styles.stepNum}>{i + 1}</span>
              <h3 className={styles.stepTitle}>{p.titulo}</h3>
              <p className={styles.stepDesc}>{p.descricao}</p>
            </div>
          </Revelar>
        ))}
      </div>
    </section>
  );
};

export default Testimonial;
